import client from 'data/client';
import { MeData } from 'data/types/me';
import { normalizeMe } from 'model/me';
import { CDError } from 'utils/error';
import identify, { identifyUnknown } from 'utils/segment';
import { update, shutdown, boot } from 'utils/intercom';
import { getAuth, signInWithCustomToken } from 'firebase/auth';

const getMe = async () => {
  const firebaseAuth = getAuth();
  try {
    const { data } = await client.get<MeData>('/me');
    const user = {
      id: data.id,
      name: `${data.user.firstName} ${data.user.lastName}`,
      email: data.user.email,
      organizationId: data.organizationId,
    };
    identify(user);
    boot();
    update(user);

    if (
      firebaseAuth.currentUser === null ||
      firebaseAuth.currentUser.uid !== data.id
    ) {
      await signInWithCustomToken(firebaseAuth, data.firebase_token);
    }

    return normalizeMe(data);
  } catch (error) {
    identifyUnknown();
    shutdown();
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export default getMe;
